import { render } from "./AddedProduct.vue?vue&type=template&id=2c6599b2"
import script from "./AddedProduct.vue?vue&type=script&lang=js"
export * from "./AddedProduct.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./AddedProduct.vue?vue&type=style&index=0&id=2c6599b2&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__